<mapfre-header></mapfre-header>
<div class="container mapfre-content">
  <div class="ie-message"  *ngIf="isIEBrowser">
    <mapfre-info-divs [additionDivClass]="'align-icon-bop'"> 
        <em>{{ 'Internet Explorer is no longer supported.' | translate }}</em><br/>
        <em> {{'Please use Chrome, Firefox, Safari, or Microsoft Edge for a better experience.'}}</em>
    </mapfre-info-divs>
</div>
<mapfre-card additionalClasses="signup guest-payment-container">

  <section class="ach-pay-block">
    <div class="margin-vertical mv16" *ngIf="invalidRouting">
      <mapfre-alert></mapfre-alert>
    </div>
    <header class="details margin-bottom mb16">
        <ng-container *ngIf="isAcmic; else MAStateAchPaymentMK">
          <div class="type-title">
            <h1 class="title">
              {{ "MAKE_A_CHECK_PAYMENT" | translate }}
            </h1>
            <div class="sub-title">
              {{ policy?.displayType?.label | translate }} -
              <strong>{{ policy?.policynumber.policyNumber }}</strong>
            </div>
          </div>
        </ng-container>
      <ng-template #MAStateAchPaymentMK>
        <h2 class="title dm-sans-medium">
          {{ "MAKE_A_CHECK_PAYMENT" | translate }}
        </h2>
        <div class="sub-title mt-4 brand-blue-secondary">
          <img 
            src="{{policy?.displayType?.icon}}"
            width="40" height="40" 
            class="mr-2"
            alt="{{policy?.policyType?.toLowerCase()}} icon"
          />
          {{ policy?.displayType?.label | translate }} -
          <strong>{{ policy?.policynumber.policyNumber }}</strong>
        </div>
      </ng-template>
    </header>
  </section>

<section class="details details-content no-padding new_payment ach-pay-block">
  <app-new-payment-form
    [policy]="policy"
    [billingDetails]="billingDetails"
    [inputs]="inputs"
    (achConfrimModal)="openConfirmModal()"
    [achPay]="true"
  >
  </app-new-payment-form>
  <ng-template> </ng-template>
</section>
</mapfre-card>
</div>

